<template>

  <div>

    <b-card no-body class="mb-1">
      <div class="m-2">
      garden filters
      </div>
    </b-card>


    <!--   button -->
    <b-card no-body class="mb-1">

      <div class="loading_page" v-if="form.busy">
        <orbit-spinner v-if="form.busy" :animation-duration="1000" :size="30" :color="'white'" />
      </div>

      <div class="m-2">
        <validation-observer ref="reportRef">
        <b-form>
          <b-row>

            <b-col sm="12" md="6" lg="6">
              <b-form-group :label="$t('Choose The Garden')" label-for="geofence">
                <validation-provider #default="{ errors }" rules="required" name="garden">
                  <v-select multiple id="geofence" v-model="form.gardens" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="gardens" :reduce="g => g.geofence_id" :getOptionLabel="g => g.name"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col sm="12" md="6" lg="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            </b-col>

            <b-col md="12" lg="6">
              <b-form-group :label="$t('select range date')" label-for="range">
                <validation-provider #default="{ errors }" rules="required" name="range date">
                  <flat-pickr id="range" :state="errors.length > 0 ? false:null" v-model="range"
                              class="form-control" :config="pickerConfig"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

          </b-row>

        </b-form>
        </validation-observer>
      </div>
    </b-card>


    <!--   button -->
    <b-card no-body class="mb-1">
      <div class="m-2">
        <b-row>
          <b-col cols="12" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <b-button size="sm" variant="primary" @click="submitReport" :disabled = "form.busy">
              <orbit-spinner v-if="form.busy" :animation-duration="1000" :size="10" :color="'white'" />
              <template v-else>{{$t('get report')}}</template>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-card v-if="result.length > 0" no-body class="mb-0">
      <div class="m-2">

        <b-row>
          <b-col cols="12" sm="3" md="3" lg="1">
            <v-select id="per-page" v-model="perPage" :clearable="false" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="[2,50,100,500]"/>
          </b-col>

          <b-col cols="10" sm="8" md="8" lg="9" >
            <b-form-input id="search" v-model="filter" :placeholder="$t('Filter ...')"/>
          </b-col>

          <b-col cols="1" sm="1" md="1" lg="2">
            <b-button variant="primary" :disabled="result.length < 1" class="btn-icon mr-1 ml-1" @click="exportReport('xlsx')">
              EXCEL<feather-icon icon="DownloadCloudIcon" />
            </b-button>
            <b-button variant="primary" :disabled="result.length < 1" class="btn-icon" @click="exportReport('pdf')">
              PDF<feather-icon icon="DownloadCloudIcon" />
            </b-button>
          </b-col>

          <b-col cols="12" class="mt-1">
            <b-table ref="myTable" id="PlansTable" small bordered hover responsive="sm" :per-page="perPage" :current-page="currentPage"
                     :busy="form.busy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter" :fields="columns" :items="result">

              <template #table-busy>
                <div class="my-2" style=" justify-content: center; align-items: center; display: flex;">
                  <orbit-spinner class="align-middle" :animation-duration="1000" :size="20" :color="'#27afba'" />
                </div>
              </template>

              <template #cell(times)="data">
               <ul>
                 <li v-for="time in data.item.times">
                   {{time}}
                 </li>
               </ul>
              </template>

              <template #cell(devices)="data">
                <ul>
                  <li v-for="device in data.item.devices">
                    {{device}}
                  </li>
                </ul>
              </template>

              <template #cell(durations)="data">
                <ul>
                  <li v-for="duration in data.item.durations">
                    {{duration}}
                  </li>
                </ul>
              </template>

            </b-table>

            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                          aria-controls="PlansTable"></b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

  </div>

</template>

<script>
import  {ref, onMounted, reactive, watch } from '@vue/composition-api';
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import InputError from '@/new/components/InputError'
import { OrbitSpinner } from 'epic-spinners'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import pickerConfig from '@/new/utils/picker'
import CustomTable from '@/new/components/CustomTable'
import Form from '@/libs/vForm'
import axios from '@/libs/axios'
import store from '@/store'
import { required } from '@core/utils/validations/validations'
import { BCard, BRow, BCol, BFormInput, BButton, BForm, BFormValidFeedback, BTable, BPagination,
  BFormInvalidFeedback, BFormGroup, BInputGroup, BModal} from 'bootstrap-vue'
import { v4 as uuid } from 'uuid'

export default {
  name: 'GGardenReport',
  components: {
    BTable,BPagination,
    ValidationProvider, ValidationObserver,
    InputError,
    BFormValidFeedback,BFormInvalidFeedback,
    OrbitSpinner,
    vSelect, flatPickr,
    BCard,BCol, BRow,BButton,
    BFormGroup, BInputGroup, BFormInput, BForm,
    CustomTable, BModal
  },


  setup(){

    // table
    const myTable = ref(null)
    const currentPage = ref(1)
    const perPage = ref(10)
    const tableBusy = ref(false)
    const sortBy = ref('')
    const sortDesc = ref('')
    const totalRows = ref(0)
    const filter = ref('')

    const reportRef = ref(null)
    const gardens = ref([])
    const range = ref('')
    const result = ref([])

    const columns = ref([{ key: 'index', label: '#', sortable: true },{ key: 'owner', sortable: true }, { key: 'contract', sortable: true },{ key: 'garden', sortable: true }, { key: 'plan', sortable: true }, { key: 'date', sortable: true },
      { key: 'countShouldBe', label: 'Count', sortable: true }, { key: 'actually', sortable: true },{key: 'times'}, {key: 'durations'}, {key: 'devices'},{ key: 'percent', sortable: true }])

    const form =  reactive(new Form({
      type: 'gGardenPlan',
      needPagination: false,
      period: 'daily',
      gardens: [],
      from: '',
      to: '',
    }))


    watch(range, (newValue, oldValue) => {
      let arr = newValue.split(' to ')
      form.from = arr[0]
      form.to = arr[1]
    });

    const submitReport = () => {
      reportRef.value.validate().then(success => {
        if (success) {
           tableBusy.value = true
           form.post('reports').then(response => {
             tableBusy.value = false
             totalRows.value = response.data.data.length
             result.value = response.data.data
           }).catch(e => {
             result.value = []
             console.log('error submit report')
           })

        }
      })
    }


    const exportReport = type => {
      reportRef.value.validate().then(success => {
        if (success) {
          tableBusy.value = true
          Object.assign(form, {exporter: type, export: "gGardenPlanReport"})
          form.post('export', {responseType: 'blob'}).then(response => {
            tableBusy.value = false
            const blob = new Blob([response.data], { type: response.headers['content-type'], encoding: 'UTF-8' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `gardenPlanReport.${type}`;
            link.click();
            URL.revokeObjectURL(url);
          }).catch(e => {
            console.log(e)
            console.log('error export report')
          })
        }
      })
    }


    const getGardens = () => {
      axios.get('userGetLinked', { params: {
        user: store.state.auth.userData.id,
          type: 'geofence', typeSlug: 'TANK_AREA'}})
          .then(setGarden()).catch(e => console.log(e))
    }

    const setGarden = () => {
      return (response) => {
        gardens.value = [{geofence_id: "all", name: "all"},...response.data.data]
      }
    }

    const getReport = ctx => {

      reportRef.value.validate().then(success => {
        if (success) {
          tableBusy.value = true
          const promise = form.post('reports');
          return promise.then(response => {
            tableBusy.value = false
            totalRows.value = response.data.data.meta.total

            const items = response.data.data.data
            return items || []
          }).catch(error => {
            tableBusy.value = false
            return []
          })
        }
      })
    }

    onMounted(() => {
      getGardens()
    })

    return {

      // table and pagination
      myTable, filter,
      currentPage, perPage, tableBusy, columns,
      totalRows,

      sortDesc, sortBy,

      reportRef,
      exportReport,
      submitReport, getReport,
      result,
      pickerConfig,
      range,
      gardens,
      form,
      required,
    }
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
